import React from 'react'
import {Editor, EditorState, convertFromRaw} from 'draft-js'


interface Props {
  data: any
}

export default function DraftContent({data}: Props) {
  const json = JSON.parse(data)

  if (!json?.blocks?.length) return null

  const contentState = convertFromRaw(json)
  const editorState = EditorState.createWithContent(contentState)

  return (
    <Editor
      editorState={editorState}
      readOnly
      onChange={() => {}}
    />
  )
}
